import { useMemo } from 'react'

import { Image } from 'antd'
import styled from 'styled-components'

import { SignatureDisplayBlock as SignatureDisplayBlockType } from '../../types/blueprint'

import { Text } from '@/components/shared-components/BUI/Text'
import { useTimezonedDates } from '@/context/timezoneContext'

const SignaturePreview = styled(Image)`
  display: block;
  width: auto; // otherwise stretches when generating PDF
  max-height: 100px;
`

type Props = {
  block: SignatureDisplayBlockType
}

export const SignatureDisplayBlock: React.FC<Props> = ({ block }) => {
  const { formatDateString } = useTimezonedDates()
  const { signeeName, time, url } = block

  const text = useMemo(() => {
    const chunks = ['Signed']

    if (signeeName?.length) {
      chunks.push('by ' + signeeName)
    }

    if (time) {
      chunks.push('on ' + formatDateString({ date: time, includeTime: true }))
    }

    return chunks.join(' ')
  }, [formatDateString, signeeName, time])

  return (
    <>
      <Text mb="0.5rem">{text}</Text>

      {url && <SignaturePreview src={url} alt="signature" />}
    </>
  )
}
